var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24451 10.4411C2.37304 8.46233 3.96395 6.91157 5.94447 6.81345C8.81239 6.67136 12.9115 6.5 16 6.5C19.0885 6.5 23.1876 6.67136 26.0555 6.81345C28.0361 6.91157 29.627 8.46233 29.7555 10.4411C29.8786 12.3369 30 14.6697 30 16.5C30 18.3303 29.8786 20.6631 29.7555 22.5589C29.627 24.5377 28.0361 26.0884 26.0555 26.1866C23.1876 26.3286 19.0885 26.5 16 26.5C12.9115 26.5 8.81239 26.3286 5.94447 26.1866C3.96395 26.0884 2.37304 24.5377 2.24451 22.5589C2.12136 20.6631 2 18.3303 2 16.5C2 14.6697 2.12136 12.3369 2.24451 10.4411Z",
    fill: "#DA7D4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.5V20.5L21 16.5L13 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYt);
export default __webpack_public_path__ + "static/media/icon_yt.557f64f111c50b7109061db9929c9e14.svg";
export { ForwardRef as ReactComponent };